import { toMercator, toWgs84 } from "@turf/projection";
import { point, lineString } from "@turf/helpers";
import { Turn } from "./turn";

export const get_turn_line = (p1, p2, p3, offset = 3, point_count = 10) => {
  const from_geom = toMercator(point(p1));
  const via_geom = toMercator(point(p2));
  const to_geom = toMercator(point(p3));
  const from = {
    x: from_geom.geometry.coordinates[0],
    y: from_geom.geometry.coordinates[1]
  };
  const via = {
    x: via_geom.geometry.coordinates[0],
    y: via_geom.geometry.coordinates[1]
  };
  const to = {
    x: to_geom.geometry.coordinates[0],
    y: to_geom.geometry.coordinates[1]
  };

  let turn = new Turn(from, via, to);
  let via1 = via;
  let from1 = from;
  let to1 = to;
  offset = Math.sin(turn.angle()) * offset;
  if (offset !== 0) {
    let from_nor_vec = turn.from_line().normal_vector();
    let to_nor_vec = turn.to_line().normal_vector();
    const bisec_offset = offset;
    via1 = {
      x:
        turn.via().x +
        turn.cross_product_sign() * turn.bisector_vec().x() * bisec_offset,
      y:
        turn.via().y +
        turn.cross_product_sign() * turn.bisector_vec().y() * bisec_offset
    };
    from1 = {
      x: turn.from().x + from_nor_vec.x() * offset,
      y: turn.from().y + from_nor_vec.y() * offset
    };
    to1 = {
      x: turn.to().x - to_nor_vec.x() * offset,
      y: turn.to().y - to_nor_vec.y() * offset
    };
  }
  if (turn.modifier() === 0) {
    via1 = {
      x: via1.x + (turn.vec_from().x() * turn.vec_from().length()) / 2,
      y: via1.y + (turn.vec_from().y() * turn.vec_from().length()) / 2
    };
  }
  turn = new Turn(from1, via1, to1);
  turn.generate_geom(point_count);
  return turn;
};

export const get_turn_wgs_line = (p1, p2, p3, offset, pointsCount) => {
  const turn = get_turn_line(p1, p2, p3, offset, pointsCount);
  const turnGeom = turn.geom();
  return toWgs84(lineString(turnGeom));
};
